































































































































































import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import NProgress from 'nprogress';
import Test from '@/servers/modules/vocabulary/test'; // server
import {
  Button, Message, Scrollbar, Card, Radio, RadioGroup, Input, Loading,
} from 'element-ui';
import MyDialog from '@/components/dialog/Index.vue'; // dialog
import moment from 'moment';
import Vocabulary from '@/servers/modules/vocabulary/vocabulary'; // server
import { OnGetOS, handleClickToAppfuncation } from '@/plugins/util'

@Component({
  components: {
    Button,
    Scrollbar,
    Card,
    Radio,
    RadioGroup,
    Input,
    MyDialog,
  },
})
export default class extends Vue {
    private navData : any;

    // @ts-ignore
    @Getter public skeleton: any;

    // @ts-ignore
    @Mutation public setSkeletonDescribe;

    // @ts-ignore
    @Mutation public openDialog;

    // @ts-ignore
    @Mutation public closeDialog;

    // 正确率
    private studentAccuracy: any = '';

    // 什么类型的数据
    private testPaperType:string = '0';

    private showPaperType:string = 'readChoose';

    private check:string = 'all';

    private remain:number = 0;

    private examinationTimer:any = '';

    private timeLeft:any = '10:00';

    private assignment:string = '';

    private questotal:number = 0;

    private dialogType: any = null;

    // 组测
    private needGroupTest: boolean = false;

    // 阶段测
    private needPhaseTest: boolean = false;

    // 后测
    private needBehindTest: boolean = false;

    // 是否后测过
    private behindTest: boolean = false;

    // 是否通过后测
    private passBehindTest: boolean = false;

    // 是否通过测试
    private testPaperState: any = null;

    // 是否复现完成， 为true才可以进入复习
    private needReviewWord: boolean = false;

    // 组测试正确率
    private needGroupTestPrice: string = '';

    // 阶段测试正确率
    private needPhaseTestPrice: string = '';

    // 后测正确率
    private needBehindTestPrice: string = '';

    private testBox:any = {
      dictationList: undefined,
      listenList: undefined,
      meansList: undefined,
      info: undefined,
    };

    private finallyFill:any = {
      dictationList: 0,
      listenList: 0,
      meansList: 0,
    };

    private back() {
      // - this.$router.go(-1);
      this.$router.push('/vocabulary');
    }

    // 计算已填写题目
    private fillProblemSum(opera: any) {
      if (opera == 'reduce') {
        this.remain--;
      } else {
        this.remain++;
        if (this.remain > this.questotal) this.remain = this.questotal;
      }
      // 不需要存储 每一次填写需要将填写后的数据进行保存
    }

    // 播放音频
    private playAudio(audio:any, item:any) {
      item.togglePlayModel = true;
      setTimeout(() => {
        item.togglePlayModel = false;
      }, 1000);
      // 触发停止播放的方法

      let isapp = localStorage.getItem('isapp') 
      let os = OnGetOS()

      if (isapp == 'android') {
        handleClickToAppfuncation('playSound',audio)
      }else {
        if (os == 'iphone') {
          this.$refs.audio.src = audio; 
          this.$nextTick(() => {
            this.$refs.audio.load()   
            this.$refs.audio.play();
          })
        }else {
          this.$refs.audio.src = audio; 
          this.$refs.audio.play();
        } 
      }
    }

    private isFirst(index:number) {
      if (index == 1 || (index != 1 && ((index - 3) % 3 == 1))) {
        return 'is-first';
      }
    }

    private barGoTop() {
      const _this = this;
      function goToTop() {
        setTimeout(() => {
          let index = 0;
          if (_this.showPaperType == 'readChoose') {
            index = 0;
          } else if (_this.showPaperType == 'listenChoose') {
            index = 1;
          } else if (_this.showPaperType == 'listenWhite') {
            index = 2;
          }
          const container = _this.$el.querySelectorAll('.el-scrollbar__wrap')[index];
          if (container.scrollTop > 0) {
            container.scrollTop -= 50;
            goToTop();
          } else {
            container.scrollTop = 0;
          }
        }, 1);
      }
      goToTop();
    }

    private audioLoad(e:Event) {
      // 加载 方法

      // 播放音频
      this.$refs.audio.onplay();
    }

    // 是否提示总复习
    private async getFinishedFlag(data: any) {
      return await Vocabulary.getFinishedFlag(data);
    }

    // 继续学习
    private continueLearning() {
      if (this.needPhaseTest) { // 阶段测
        this.openDialog({
          visible: true,
          titleClose: true,
          titleIcon: false,
          text: '阶段测试',
          footer: [
            {
              class: 'button-style-border',
              word: '复习本阶段',
            },
            {
              class: 'button-style-background',
              word: '测试本阶段',
            },
          ],
        });
        this.dialogType = 'needPhaseTest';
        return false;
      }
      if (this.needBehindTest) { // 触发后测
        this.openDialog({
          visible: true,
          titleClose: true,
          titleIcon: false,
          text: '后测',
          footer: [
            {
              class: 'button-style-border',
              word: '复习课程',
            },
            {
              class: 'button-style-background',
              word: '进入后测',
            },
          ],
        });
        this.dialogType = 'needBehindTest';
        return false;
      }
      if (this.behindTest && !this.passBehindTest) {
        this.$router.push(
          {
            path: '/vocabulary/study',
            query: {
              studyType: 6,
            },
          },
        );
        return false;
      }
      if (this.behindTest && this.passBehindTest) {
        // 判断是否触发过复习提示，若没有，则触发
        const params = {
          userCourseId: window.LS.get('vteData').userCourseId,
        };
        this.getFinishedFlag(params).then((res) => {
          if (res.status == 200) {
            if (res.data.code == 0) {
              if (res.data.data == 1) {
                // 跳转提示
                this.$router.push({
                  path: '/vocabulary/prompt',
                  query: {
                    type: 'review',
                  },
                });
              } else {
                // 跳转学习
                this.$router.push({
                  path: '/vocabulary/study',
                  query: {
                    studyType: 7,
                  },
                });
              }
            }

          }
        });
        return false;
      }
      // 判断是否需要组测和阶段测
      if (this.needGroupTest) {
          this.openDialog({
                  visible: true,
                  titleClose: true,
                  titleIcon: false,
                  text: '组测试',
                  footer: [
                      {
                          class: 'button-style-border',
                          word: '复习本组',
                      },
                      {
                          class: 'button-style-background',
                          word: '测试本组',
                      },
                  ],
              });
              this.dialogType = 'needGroupTest';
              return false;
      }
      // 2 通过 3 不通过
      if (this.testPaperState == 2) {
        this.$router.replace(
          {
            path: '/vocabulary/study',
            query: {
              studyType: 0,
            },
          },
        );
      }
      // // 需要组测
      // if (this.needGroupTest) {
      //   //  this.$router.push(
      //   //     {
      //   //         path: '/vocabulary/study',
      //   //         query: {
      //   //             studyType: 2,
      //   //             }
      //   //     }
      //   // )
      //   this.openDialog({
      //     visible: true,
      //     titleClose: true,
      //     titleIcon: false,
      //     text: '组测试',
      //     footer: [
      //       {
      //         class: 'button-style-border',
      //         word: '复习本组',
      //       },
      //       {
      //         class: 'button-style-background',
      //         word: '测试本组',
      //       },
      //     ],
      //   });
      //   this.dialogType = 'needGroupTest';
      //   return false;
      // }
      if (this.needReviewWord) {
        this.$router.push(
          {
            path: '/vocabulary/study',
            query: {
              studyType: 5,
              // inputWay: 2,
            },
          },
        );
      }
      // if (this.testPaperState == 3) {
      //     this.$router.replace(
      //         {
      //             path: '/vocabulary/study',
      //             query: {
      //                 studyType: 2,
      //                 }
      //         }
      //     )
      // }
    }

    private async getCheckIsNeedTest(data: any) {
      return await Vocabulary.getCheckIsNeedTest(data);
    }

    private sure() {
      this.$router.push('/vocabulary');
      // this.$router.go(-1)
      // 判断是否开启下一阶段测试，将首页逻辑复制到此处
    }

    // 提交试卷
    private submitAssignment(time:any) {
      const _this = this;
      // 提交试卷时 清空所有存在的数据
      this.finallyFill = {
        dictationList: 0,
        listenList: 0,
        meansList: 0,
      };
      noFill(this.testBox.meansList, 'meansList');
      noFill(this.testBox.listenList, 'listenList');
      noFill(this.testBox.dictationList, 'dictationList');
      function noFill(data:any, name:any) {
        try {
          for (let i = 0; i < data.length; i++) {
            if (data[i].userAnswer == null) {
              _this.finallyFill[name] = Number(_this.finallyFill[name]) + 1;
            }
          }
        } catch (e) {
        }
      }
      const noFillList = [];
      if (this.finallyFill.dictationList) {
        noFillList.push(`<span class="blastingenglish-orange">${this.finallyFill.dictationList}道</span>听写题`);
      }
      if (this.finallyFill.listenList) {
        noFillList.push(`<span class="blastingenglish-orange">${this.finallyFill.listenList}道</span>听辨题`);
      }
      if (this.finallyFill.meansList) {
        noFillList.push(`<span class="blastingenglish-orange">${this.finallyFill.meansList}道</span>释义题`);
      }

      // 当有时间传入进来时 表示 时间截止 关闭弹窗
      if (time == 'time') {
        this.closeDialog();
        this.dialogHandle(1);
      } else
      // 全部填写完毕了 并且倒计时不为 00:00 时表明提前交卷
      if (noFillList.length > 0 && this.timeLeft != '00:00') {
        this.assignment = `您还有${noFillList.join('、')}没有完成，确认要交卷吗？`;
        this.openDialog({
          visible: true,
          titleClose: true,
          titleIcon: true,
          text: '确认交卷',
          footer: [
            {
              class: 'button-style-border',
              word: '取消',
            },
            {
              class: 'button-style-background',
              word: '确认',
            },
          ],
        });
      }
      // 表示全部填写完毕
      else if (noFillList.length <= 0) {
        this.dialogHandle(1);
      }
    }

    private async dialogHandle(index:number) {
      if (this.dialogType == 'needPhaseTest') {
        if (index == 0) {
          this.$router.push(
            {
              path: '/vocabulary/study',
              query: {
                studyType: 4,
              },
            },
          );
        } else if (index == 1) {
          window.LS.set('BlastingEnglish_test_query', { time: 15, testPaperType: '3' });
          this.$router.replace('/vocabulary/test');
        }
      } else if (this.dialogType == 'needGroupTest') {
        if (index == 0) {
          this.$router.push(
            {
              path: '/vocabulary/study',
              query: {
                studyType: 2,
              },
            },
          );
        } else if (index == 1) {
          window.LS.set('BlastingEnglish_test_query', { time: 15, testPaperType: '2' });
          this.$router.replace('/vocabulary/test');
        }
      } else if (this.dialogType == 'needBehindTest') {
        if (index == 0) {
          if (!this.behindTest) {
            this.$router.push(
              {
                path: '/vocabulary/study',
                query: {
                  studyType: 5,
                },
              },
            );
          } else if (this.behindTest && !this.passBehindTest) {
            this.$router.push(
              {
                path: '/vocabulary/study',
                query: {
                  studyType: 6,
                },
              },
            );
          } else if (this.behindTest && this.passBehindTest) {
            this.$router.push(
              {
                path: '/vocabulary/study',
                query: {
                  studyType: 7,
                },
              },
            );
          }
        } else if (index == 1) {
          window.LS.set('BlastingEnglish_test_query', { time: 15, testPaperType: '4' });
          this.$router.replace('/vocabulary/test');
        }
      } else if (index === 0) {
        this.closeDialog();
      }
      // 交卷子
      else if (index === 1) {
        // 提交试卷后清空定时器
        clearInterval(this.examinationTimer);
        // 等待对接 提交试卷的接口
        this.closeDialog();
        const paper = Loading.service({ text: '交卷中' });
        this.testBox.info.dictationList = this.testBox.dictationList;
        this.testBox.info.listenList = this.testBox.listenList;
        this.testBox.info.meansList = this.testBox.meansList;
        this.testBox.info.testTime = Number(`${new Date().getTime().toString().substr(0, 9)}0999`);
        const res = await Test.saveStudentTestResult(this.testBox.info);
        window.LS.remove('BlastingEnglish_test_query');
        paper.close();
        // this.$router.go(-1);
        if (!res.data.code) {
          Message('提交成功');
          // 提交 试卷 并获取答题详情
          this.testDetails(this.testBox.info.testId);
          // this.$router.go(-1);
        } else {
          Message('提交失败');
          // 重新再次提交
          await this.dialogHandle(1);
        }
      }
    }

    private created() {
      const paper = Loading.service({ text: '试卷整合中，请稍后……' });
      this.navData = window.LS.get('basicData').courseName;
      this.setSkeletonDescribe(true);
      this.closeDialog();
      NProgress.start();
      // this.getStudyList();
      // this.getCheckIsNeedTest();
      const parameter = {
        userCourseId: window.LS.get('vteData').userCourseId,
        userId: window.LS.get('vteData').user.userId,
        courseId: window.LS.get('vteData').course.courseId,
      };
        // 1 获取试卷 2 获取需要的考试
      Promise.all([
        this.getStudyList(),
        this.getCheckIsNeedTest(parameter),
      ]).then((res: any) => {
        paper.close();
        if (!res[0].data.code) {
          this.setSkeletonDescribe(true);
          const list = res[0].data.data;
          this.testPaperType = list.testPaperType;
          this.studentAccuracy = res[0].data.data.userAccuracy;

          // 是否通过测试
          this.testPaperState = res[0].data.data.testPaperState;

          // 释义题
          // list.meansList
          // 听辨题
          // list.listenList
          // 听写题
          // list.dictationList
          const _this = this;
          _this.questotal = 0;
          this.testBox.info = list;
          if (list.dictationList) {
            this.testBox.dictationList = addLabel(list.dictationList);
          }
          if (list.listenList) {
            this.testBox.listenList = addLabel(list.listenList);
          }
          if (list.meansList) {
            this.testBox.meansList = addLabel(list.meansList);
          }
          function addLabel(data:any) {
            for (let i = 0; i < data.length; i++) {
              data[i].isShow = true;
              // 获取学生回答的正确答案：
              if (data[i].userAnswer == 'A') {
                data[i].userAnswer = data[i].option1;
              } else if (data[i].userAnswer == 'B') {
                data[i].userAnswer = data[i].option2;
              } else if (data[i].userAnswer == 'C') {
                data[i].userAnswer = data[i].option3;
              } else if (data[i].userAnswer == 'D') {
                data[i].userAnswer = data[i].option4;
              }
              data[i].answer = data[i].userAnswer;

              // data[i].togglePlayModel = false
              Vue.set(data[i], 'togglePlayModel', false);
              // 后台返回表示 1为错误 0为正确 answerClass 表明当前的选项是否正确
              if (data[i].right) {
                data[i].answerClass = 'wrong';
                data[i].answer_img = require('../../assets/images/ui-word/word-answer-wrong.png');
              } else {
                data[i].answerClass = 'success';
                data[i].answer = data[i].userAnswer;
                _this.remain++;
                data[i].answer_img = require('../../assets/images/ui-word/word-answer-right.png');
              }
            }
            _this.questotal += data.length;
            return data;
          }

          if (this.testBox.dictationList == undefined && this.testBox.listenList == undefined) {
            this.showPaperType = 'readChoose';

          } else if (this.testBox.meansList == undefined && this.testBox.listenList == undefined) {
            this.showPaperType = 'listenWhite';

          }
        } else {
        }

        // 判断是否需要各种测
        this.needPhaseTest = res[1].data.data.needPhaseTest;
        this.needBehindTest = res[1].data.data.needBehindTest;
        // behindTest 是否测过
        this.behindTest = res[1].data.data.behindTest;
        // passBehindTest 是否通过
        this.passBehindTest = res[1].data.data.passBehindTest;
        // 组测
        this.needGroupTest = res[1].data.data.needGroupTest;
        // 是否可以复习 为true应该为去复习
        this.needReviewWord = res[1].data.data.needReviewWord;
        this.needGroupTestPrice = res[1].data.data.groupPassPrice;
        this.needPhaseTestPrice = res[1].data.data.phasePassPrice;
        this.needBehindTestPrice = res[1].data.data.behindPassPrice;
        NProgress.done();
      });
    }

    private changeNow(data:any, item:any) {
      if (data.isShow) {
        data.userAnswer = data.answer;
        return false;
      }
      if (!data.answer) {
        this.fillProblemSum('reduce');
      }
      data.answer = item;
    }

    private changeInput(data:any, item:any) {

      if (!data.answer) {
        this.fillProblemSum('reduce');
      }
      // 左右去空后
      if (item == '') {
        // 将已填写置为空
        data.answer = undefined;
        this.fillProblemSum('add');
      }
      data.answer = item;
    }

    // 通过学生编号和课程编号查询试卷题目详情
    private startTime: any = moment();

    private endTime: any = '';

    private get countDown() {
      return () => {
        const m1: any = this.startTime;
        const m2: any = this.endTime;
        const du = moment.duration(m2 - m1, 'ms');
        const mins = du.get('minutes');
        const ss = du.get('seconds');
        if (mins <= 0 && ss <= 0) {
          this.submitAssignment('time');
          return '00:00';
        }
        return `${this.PrefixInteger(mins, 2)}:${this.PrefixInteger(ss, 2)}`;
      };
    }

    private PrefixInteger(num: any, n: any) {
      return (Array(n).join('0') + num).slice(-n);
    }

    private async getStudyList() {
      return await Test.getStudentTestById({ id: this.$route.query.testId });
      // 开启定时器 - 倒计时
      // this.examinationTimer = setInterval(() => {
      //     this.timeLeft = this.countDown();
      //     this.startTime = moment();
      // }, 1000);
    }

    // 筛选题目
    private async filterTopics(text:any) {
      this.check = text;
    }

    private isFilter(item:any) {
      if (this.check != 'all') {
        if (this.check == 'chose' && !item.answer) {
          return 'none-show';
        }
        if (this.check == 'none' && item.answer) {
          return 'none-show';
        }
      } else {
        return '';
      }
    }

    private destroyed() {
      clearInterval(this.examinationTimer);
    }

    private beforeDestroy() {
      clearInterval(this.examinationTimer);
    }
}
